import React from "react";
import { ErrorMessage, Field } from "formik";
import { FormikDropdown } from "../../../FormikDropdown";
import { Flex } from "../../../Flex";
import { FormInputErrorMessage } from "../../../FormInputErrorMessage";

interface Props {
  id: string;
}

export const DisconnectionDetailsReason: React.FC<Props> = ({ id }) => {
  return (
    <Flex
      id={id}
      flexDirection="column"
      flexGrow={0.3}
      flexBasis={0}
      minWidth={["100%", "100%", "100%", 0]}
      maxWidth={"422px"}
      mb={[4, 4, 4, 4]}
      mt={0}
    >
      <Field
        id={"disconnectionDetails.removalReason"}
        name={"disconnectionDetails.removalReason"}
        label="Reason for removal or disconnection"
        items={[
          "Demolition",
          "Building removal",
          "Combine & Centralise request",
          "Unmetered supply removal",
          "Builders Temporary Supply (BTS) removal",
        ]}
        visibleItems={5}
        placeholder="Select Item"
        component={FormikDropdown}
      />
      <ErrorMessage
        name="disconnectionDetails.removalReason"
        className="field-error"
        component={FormInputErrorMessage}
      />
    </Flex>
  );
};
